/* playButtonWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./playButtonWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N0 } from '@atlaskit/theme/colors';
import { playButtonClassName } from './styles';
var playButtonWrapperStyles = null;
export var PlayButtonWrapper = function PlayButtonWrapper(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _syazw5hi _vr2wstnw", playButtonClassName]),
    style: {
      "--_1qgzj18": ix("var(--ds-icon-inverse, ".concat(N0, ")"))
    }
  }, props.children);
};